import { render, staticRenderFns } from "./contentDetail.vue?vue&type=template&id=16ee6ff0&"
import script from "./contentDetail.vue?vue&type=script&lang=ts&"
export * from "./contentDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports